import supportModule from '../../support.module';

export default supportModule.component('supportFeedAttachment', {
    template: require('./supportFeedAttachment.component.html'),
    style: require('./supportFeedAttachment.component.css'),
    controller: controller,
    bindings: {
        fileName: '<',
        link: '<',
        showIcon: '<'
    }
});

function controller(asImageOverlay, imageHelper) {
    var vm = this;
    vm.asImageOverlay = asImageOverlay;
    vm.imageHelper = imageHelper;

    vm.showImageOverlayOrDownload = () => {
        if (vm.hasImageExtension()) {
            this.asImageOverlay.render(vm.link);
        }
    };

    vm.hasImageExtension = () => {
        return vm.fileName && imageHelper.hasImageExtension(vm.fileName);
    };
}



// WEBPACK FOOTER //
// ./modules/support/components/support-feed-attachment/supportFeedAttachment.component.js